import axios from "axios";
import { apiDomain } from "@/store/constants"

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true; // now
axios.defaults.baseURL = apiDomain;